mutation MessageUserCreate($input: MessageUserCreateInput!) {
  messageUserCreate(input: $input) {
    clientMutationId
  }
}
